module.exports = __webpack_public_path__ + "img/179-ireland.7041439e.svg";